const DIRECTORY_TAB_GROUP = '/(secure)/(tabs)/(directory)';

/**
 * Secure screens that every tab can push, whose home is the Directory tab when nothing else
 * decides. Library's own shared screens (a post, a content item) are left out because the
 * router already lands them in Library.
 */
const DIRECTORY_HOME_PATTERN =
  /^\/(profile\/(?!sms-notification-modal(?:\/|$))[^/]+|fellows|directory\/inquiry|inquiry\/new)(\/|$)/;

/**
 * Names the tab a secure screen opens in when the reader is arriving from outside every tab.
 *
 * Screens opened from a tab live in a copy per tab, and a push picks the copy in the tab the
 * reader is already in. With no tab to stay in, as for a link opened from outside the app,
 * the public-to-secure forward or a resumed destination after sign-in, every copy ties and the
 * router picks the Library tab by name. The Directory tab is the right home for a profile, an
 * inquiry being written and the screens around them, so this spells it out.
 *
 * Pass a secure destination only. A path the open group serves for a signed-out visitor would
 * be pulled into the secure group by this and lose its public page.
 */
export function toHomeTabPath(destination: string): string {
  const [pathname] = destination.split('?');

  if (!pathname || !DIRECTORY_HOME_PATTERN.test(pathname)) {
    return destination;
  }

  return `${DIRECTORY_TAB_GROUP}${destination}`;
}
